import React from "react";
import {
    Accordion,
    AccordionGroup,
    AccordionSummary,
    AccordionDetails,
    Stack,
    Typography,
} from "@mui/joy";
import ExpandMore from "@mui/icons-material/ExpandMore";
import RelatedFragmentNode from "./RelatedFragmentNode";
import { ApiFragmentNode } from "../../shared/interfaces";
import FloatingRelatedItemsLoadingIndicator from "./FloatingRelatedItemsLoadingIndicator";

interface RelatedDrawingsItemsProps {
    drawingsByLetter: Record<string, ApiFragmentNode[]>;
    setFragmentNode: (node: ApiFragmentNode | null) => void;
    isLoading: boolean;
    DRAWING_TYPE_MAPPING: Record<string, string>;
    styles: any;
}

export default function RelatedDrawingsItems({
    drawingsByLetter,
    setFragmentNode,
    isLoading,
    DRAWING_TYPE_MAPPING,
    styles,
}: RelatedDrawingsItemsProps) {
    const hasGroupedDrawings = Object.keys(drawingsByLetter || {}).length > 0;
    return (
        <>
            {hasGroupedDrawings && (
                <AccordionGroup>
                    {Object.entries(drawingsByLetter).map(([letter, nodes]) => (
                        <Accordion key={letter}>
                            <AccordionSummary indicator={<ExpandMore />}>
                                <Typography level="title-sm">
                                    {DRAWING_TYPE_MAPPING[letter] || letter} ({nodes.length})
                                </Typography>
                            </AccordionSummary>
                            <AccordionDetails>
                                <Stack>
                                    {nodes.map((node) => (
                                        <RelatedFragmentNode
                                            key={node.id}
                                            node={node}
                                            setFragmentNode={setFragmentNode}
                                        />
                                    ))}
                                </Stack>
                            </AccordionDetails>
                        </Accordion>
                    ))}
                </AccordionGroup>
            )}
            {isLoading && <FloatingRelatedItemsLoadingIndicator />}
        </>
    );
}
